import { SendOption } from "../../ConfirmAndSendStep/SendOptions";
import { CurrentBalanceSection } from "./components/CurrentBalanceSection";
import { DownloadSummarySection } from "./components/DownloadSummarySection";
import { PhysicalSendSummarySection } from "./components/PhysicalSendSummarySection";
import classNames from "clsx";

export type PaymentSummaryProps = {
  sendOption: SendOption;
  onBalanceLoaded?: (balance: number) => void;
  onTotalCostCalculated?: (totalCost: number) => void;
};
export const PaymentSummary = ({ sendOption, onBalanceLoaded, onTotalCostCalculated }: PaymentSummaryProps) => {
  return (
    <div
      className={classNames("w-[330px]", "h-fit", "border", "border-border-action", "rounded-lg")}
      data-testid="letter-payment-summary-wrapper"
    >
      <CurrentBalanceSection onBalanceLoaded={onBalanceLoaded} />

      {
        {
          [SendOption.Download]: <DownloadSummarySection />,
          [SendOption.Send]: <PhysicalSendSummarySection onTotalCostCalculated={onTotalCostCalculated} />,
        }[sendOption]
      }
    </div>
  );
};
